import React from "react";
import { useCompareV2Selector } from "../../../redux/store";
import * as CompareSectionStyles from "../styles/CompareSection";
import * as Flex from "../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Text from "../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import * as LinkToggle from "../../../../../common-deprecated/styles/v2/lexus/components/Toggle";
import * as Toggle from "../../../../../common-deprecated/styles/v2/lexus/components/FinanceToggle";
import Icon from "../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { ToggleIconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import type { CompareV2LabelType } from "../../../utils/labels";
import { CompareV2Label } from "../../../utils/labels";
import { isRTL } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import ButtonWithIcon from "../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";

type SectionHeaderType = {
    title: CompareV2LabelType;
    setOnlyShowDifferences: (show: boolean) => void;
    onlyShowDifferences: boolean;
    description: string;
    showToggleDifferences: boolean;
    toggleShowAllSpecs: (show: boolean) => void;
    showAllSpecs: boolean;
    isPdf?: boolean;
};

// TO DO: Update style LinkToggle

const SectionHeader = ({
    title,
    setOnlyShowDifferences,
    onlyShowDifferences,
    description,
    showToggleDifferences,
    toggleShowAllSpecs,
    showAllSpecs,
    isPdf,
}: SectionHeaderType): JSX.Element => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    return (
        <CompareSectionStyles.Header>
            <CompareSectionStyles.Title>
                <CompareV2Label label={title} />
            </CompareSectionStyles.Title>
            <CompareSectionStyles.Description mb={3} isPdf={isPdf}>
                <Text.Body>
                    <CompareV2Label label={description as CompareV2LabelType} />
                </Text.Body>
            </CompareSectionStyles.Description>
            <Flex.Row mx={0}>
                {showToggleDifferences && (
                    <Flex.Col width={{ _: 1 }} textAlign={isRTL(commonSettings) ? "right" : "left"} px={0}>
                        {isPdf ? (
                            <LinkToggle.Wrapper>
                                <LinkToggle.Item active>
                                    <CompareV2Label
                                        label={
                                            onlyShowDifferences ? "compareBodyShowDifferences" : "compareBodyShowAll"
                                        }
                                    />
                                </LinkToggle.Item>
                            </LinkToggle.Wrapper>
                        ) : (
                            <Toggle.Wrapper fullWidth isActive={onlyShowDifferences}>
                                <Toggle.ToggleItem
                                    isActive={!onlyShowDifferences}
                                    onClick={() => setOnlyShowDifferences(false)}
                                >
                                    <Toggle.LineClamp>
                                        <CompareV2Label label="compareBodyShowAll" />
                                    </Toggle.LineClamp>
                                </Toggle.ToggleItem>
                                <Toggle.ToggleItem
                                    isActive={onlyShowDifferences}
                                    onClick={() => setOnlyShowDifferences(true)}
                                >
                                    <Toggle.LineClamp>
                                        <CompareV2Label label="compareBodyShowDifferences" />
                                    </Toggle.LineClamp>
                                </Toggle.ToggleItem>
                            </Toggle.Wrapper>
                        )}
                    </Flex.Col>
                )}
                {!isPdf ? (
                    <Flex.Col width={{ _: 1 }} mt={3} px={0}>
                        <ButtonWithIcon onClick={() => toggleShowAllSpecs(!showAllSpecs)}>
                            <Text.IconButton ml={isRTL(commonSettings) ? 0 : 1} mr={isRTL(commonSettings) ? 1 : 0}>
                                <CompareV2Label
                                    label={showAllSpecs ? "compareBodyCollapseAll" : "compareBodyExpandAll"}
                                />
                            </Text.IconButton>
                            <ToggleIconWrapper iconColor="black" isDown={!showAllSpecs}>
                                <Icon variant="chevronDown" />
                            </ToggleIconWrapper>
                        </ButtonWithIcon>
                    </Flex.Col>
                ) : null}
            </Flex.Row>
        </CompareSectionStyles.Header>
    );
};

export default SectionHeader;
